import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { FinancialYearProvider } from "./contexts/FinancialYearContext";
import { PermissionsProvider } from "./contexts/PermissionsContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { HandoffProvider } from "./contexts/HandoffContext";
import { QuickAccessProvider } from "./contexts/QuickAccessContext";
import { MaintenanceProvider } from "./contexts/MaintenanceContext";
import { TabsProvider } from "./contexts/TabsContext";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import AppRoutes from "./AppRoutes";
import TabFrames from "./components/layout/TabFrames";
import PresenceHeartbeat from "./components/PresenceHeartbeat";

// Route tree lives in AppRoutes.jsx. TabFrames renders it once per open tab
// (keep-alive browser-style tabs) plus a live copy for tabless pages.
function App() {
  return (
    <ErrorBoundary>
    <ThemeProvider>
      <AuthProvider>
        <MaintenanceProvider>
        <PermissionsProvider>
          <QuickAccessProvider>
            <NotificationProvider>
              <HandoffProvider>
                <FinancialYearProvider>
                  <BrowserRouter>
                    <PresenceHeartbeat />
                    <TabsProvider>
                      <TabFrames routes={<AppRoutes />} />
                    </TabsProvider>
                  </BrowserRouter>
                  <Toaster position="top-right" richColors />
                </FinancialYearProvider>
              </HandoffProvider>
            </NotificationProvider>
          </QuickAccessProvider>
        </PermissionsProvider>
        </MaintenanceProvider>
      </AuthProvider>
    </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
